export default {
    inputInserted() {
        gtag('event', 'link_insert');
    },
    searchStarted(typeSubmit) {
        gtag('event', 'link_submit' , {
            'type_submit': typeSubmit,
        });
    },
    errorOccured(error) {
        gtag('event', 'vidacha_error', {
            'errror_type': error
        });
    },
    resultReceived() {
        gtag('event', 'vidacha_show');
    },
    sendDownloadFormat(type) {
        gtag('event', 'vidacha_download_click', {
            'format': type
        })
    }
}
